import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "disease-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { addDisease, updateDisease } from "@/service/modules/scan";
import { getDictCategoryList, getDictListById } from "@/service/modules/dict";
export default /*@__PURE__*/_defineComponent({
  __name: 'disease-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const nameList = ref([]);
    const categoryList = ref([]);
    const form = reactive({
      category_id: "",
      title_id: ""
    });
    const id = ref(null);
    const rules = {
      category_id: [{
        required: true,
        message: "请选择类目",
        trigger: "change"
      }],
      title_id: [{
        required: true,
        message: "请选择名称",
        trigger: "change"
      }]
    };
    getList();
    async function getList() {
      try {
        let res = await getDictCategoryList();
        categoryList.value = res.data;
      } catch (error) {
        console.log(error);
      }
    }
    // 添加监听类目变化的函数，获取对应的名称列表
    watch(() => form.category_id, async newCategoryId => {
      if (newCategoryId) {
        try {
          const res = await getDictListById(newCategoryId);
          nameList.value = res.data || [];
        } catch (error) {
          console.log(error);
          nameList.value = [];
        }
      } else {
        nameList.value = [];
      }
      // 重置名称选择
      form.title_id = "";
    });
    function restForm() {
      id.value = null;
      form.category_id = "";
      form.title_id = "";
      form.name = "";
      nameList.value = [];
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      emit("closeDialog");
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      try {
        if (props.dialogType === "add") {
          let query = JSON.parse(JSON.stringify(form));
          await addDisease(query);
          ElMessage.success("添加成功");
          emit("restData");
        } else if (props.dialogType === "edit") {
          let query = JSON.parse(JSON.stringify(form));
          query.id = id.value;
          await updateDisease(query);
          ElMessage.success("修改成功");
        }
        subBtnLoading.value = false;
        closeDialog();
        emit("restData");
      } catch {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加名称";
      } else if (props.dialogType === "edit") {
        return "编辑名称";
      }
    });
    watch(() => props.dialogVisible, async newV => {
      console.log("newV", newV, props);
      if (newV && props.dialogType === "edit") {
        id.value = props.itemData.id;
        form.category_id = props.itemData.category_id;
        // 先获取名称列表，再设置选中的名称
        if (form.category_id) {
          try {
            const res = await getDictListById(form.category_id);
            nameList.value = res.data || [];
            nextTick(() => {
              form.title_id = props.itemData.title_id;
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "类目",
            prop: "category_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.category_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.category_id = $event),
              filterable: "",
              placeholder: "类目",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.name = $event),
              filterable: "",
              placeholder: "请选择名称",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nameList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.name
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});